import { motion } from "framer-motion";
import { WhatsAppIcon } from "./Reveal";
import { WA_DEFAULT } from "@/lib/site";

export default function WhatsAppFloat() {
  return (
    <motion.a
      href={WA_DEFAULT}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat on WhatsApp"
      className="fixed bottom-5 right-5 sm:bottom-6 sm:right-6 z-50 group"
      initial={{ opacity: 0, scale: 0, y: 24 }}
      animate={{ opacity: 1, scale: 1, y: 0 }}
      transition={{ delay: 1.6, type: "spring", stiffness: 260, damping: 18 }}
      data-testid="whatsapp-float-button"
    >
      <span className="absolute inset-0 rounded-full bg-emerald-500 animate-pulse-ring" />
      <span className="relative flex h-14 w-14 items-center justify-center rounded-full bg-emerald-500 text-white shadow-glow-emerald group-hover:bg-emerald-400 group-hover:scale-105 transition-all duration-300">
        <WhatsAppIcon className="h-7 w-7" />
      </span>
      <span className="pointer-events-none absolute right-full top-1/2 -translate-y-1/2 mr-3 whitespace-nowrap rounded-full glass px-4 py-2 text-xs text-white opacity-0 -translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-300">
        Chat on WhatsApp
      </span>
    </motion.a>
  );
}
